import React, {useState} from "react"
import {FieldTableCellProps} from "../../../../../render/table/table-cell";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../gd-components/buttons/control-button/control-button-standard";
import {currencySymbol} from "../../../../../../gd/format/currency-symbol";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false


export default function FieldItemModelCalculatedExpenses_TableCell(props:FieldTableCellProps) {

    let isEditable  : boolean   = !props.manager.isReadOnly && props.listItem.item.acl.canAddExpense

    // STATE & hovered
    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isEditable) return

        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }
    //

    const addExpense = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return

        if (props.listItem.isTask) {
            gd.modules.expenses.newTaskExpense(props.listItem.task)
        }

        if (props.listItem.isProject) {
            gd.modules.expenses.newProjectExpense(props.listItem.project.id)
        }
    }

    const getStyle = () => {

        // this is common part for table cell
        // end common part

        const width = props.column.width ? props.column.width : props.manager.columnsManager.getColumnWidth(props.column)

        const style : style = _.clone(props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    const renderHovered = () => {

        const classes       = Classes("cell-flex is-hovered")
        const showChildren  = props.listItem.isCollapsed && props.listItem.calculatedExpenses.children>0

        return (
            <React.Fragment>
                <div className={classes} style={getStyle()} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} >
                    <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={addExpense}>
                        <div className="flex-row-left-center truncate">

                            {props.listItem.calculatedExpenses.own>0 &&
                                <>
                                    <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                                    <div className="ui5-txt-less-important-small">{props.field.getDisplayValue(props.listItem.calculatedExpenses.own)}</div>
                                </>
                            }

                            {showChildren && props.listItem.calculatedExpenses.own>0 &&
                                <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>
                            }

                            {showChildren &&
                                <>
                                    <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                                    <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                                    <div className="ui5-txt-less-important-small">{props.field.getDisplayValue(props.listItem.calculatedExpenses.children)}</div>
                                </>
                            }
                        </div>
                        <div className="buttons">
                            <ControlButtonStandard className="btn-add" type={ControlButtonType.PLUS} hint="Add Expense" onClick={addExpense} size={24} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    const renderNotHovered = () => {
        const classes = Classes("cell-flex ui5-txt-less-important-small ui5-field-editable size-small", {
        })

        let notHoveredContent   = null
        let showSummary         = false

        if (props.listItem.isCollapsed && props.listItem.calculatedExpenses.total && props.listItem.calculatedExpenses.total!=props.listItem.calculatedExpenses.own) {
            notHoveredContent = props.field.getDisplayValue(props.listItem.calculatedExpenses.total)
            showSummary = true
        } else if (props.listItem.calculatedExpenses.own) {
            notHoveredContent = props.field.getDisplayValue(props.listItem.calculatedExpenses.own)
        } else {
            // display nothing :)
        }

        return (
            <React.Fragment>
                <div className={classes} style={getStyle()} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}
                    {notHoveredContent && <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>}
                    {notHoveredContent}
                </div>
            </React.Fragment>
        )
    }
    // debug && console.log(debug, "render()", this.props)
    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) return renderHovered()
    else return renderNotHovered()
}
